import React, { useState } from 'react';
import { FaSearch, FaSlidersH, FaAngleDown } from 'react-icons/fa';

const WorkflowToolbar = ({ onSearch, onSort }) => {
  const [searchText, setSearchText] = useState('');
  const [sortOpen, setSortOpen] = useState(false);
  const [sortOption, setSortOption] = useState('last updated');

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchText(value);
    onSearch(value); // Trigger the search logic
  };

  const toggleSort = () => {
    setSortOpen(!sortOpen);
  };

  const handleSortChange = (option) => {
    setSortOption(option);
    onSort(option); // Trigger the sort logic
    setSortOpen(false);
  };

  return (
    <div style={{ display: 'flex', gap: '10px', padding: '0px' }}>
      {/* Search Box */}
      <div style={{ position: 'relative' }}>
        <FaSearch
          style={{
            left: '10px',
            top: '15px',
            position: 'absolute',
            color: '#A1A1A1',
          }}
        />
        <input
          type="text"
          placeholder="Search workflows..."
          value={searchText}
          onChange={handleSearchChange}
          style={{
            padding: '10px',
            width: '300px',
            borderRadius: '4px',
            border: '1px solid #ccc',
            fontSize: '14px',
            paddingLeft: '30px',
          }}
        />
      </div>

      {/* Sort By Dropdown */}
      <div style={{ position: 'relative' }}>
        <button
          onClick={toggleSort}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '5px',
            padding: '10px 15px',
            borderRadius: '4px',
            border: '1px solid #ccc',
            backgroundColor: '#fff',
            cursor: 'pointer',
          }}
        >
          Sort by {sortOption} <FaAngleDown style={{ color: '#A1A1A1' }} />
        </button>
        {sortOpen && (
          <div
            style={{
              position: 'absolute',
              top: '40px',
              right: '0',
              backgroundColor: '#fff',
              border: '1px solid #ccc',
              borderRadius: '4px',
              boxShadow: '0px 4px 8px rgba(0,0,0,0.1)',
              zIndex: 100,
              textTransform: 'capitalize',
            }}
          >
            {['name', 'last updated', 'created date', 'active'].map(
              (option) => (
                <div
                  key={option}
                  onClick={() => handleSortChange(option)}
                  style={{
                    padding: '10px',
                    cursor: 'pointer',
                    textAlign: 'left',
                  }}
                >
                  {option}
                </div>
              )
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default WorkflowToolbar;
